(function () {
  function initCountdown() {
    const countdownTimer = document.getElementById("countdown-timer");
    const daysElement = document.getElementById("days");
    const hoursElement = document.getElementById("hours");
    const minutesElement = document.getElementById("minutes");
    const secondsElement = document.getElementById("seconds");

    // Se il countdown non è presente nella pagina, non eseguire lo script.
    if (
      !countdownTimer ||
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }

    // Termine Cyber Monday 2026, ora italiana.
    const countdownDate = new Date(
      "2026-11-30T23:59:59+01:00"
    ).getTime();

    function updateCountdown() {
      const now = Date.now();
      const distance = countdownDate - now;

      if (distance <= 0) {
        clearInterval(intervalId);
        countdownTimer.innerHTML =
          '<p class="expired">OFFERTA SCADUTA</p>';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
          (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) /
          (1000 * 60)
      );
      const seconds = Math.floor(
        (distance % (1000 * 60)) / 1000
      );

      daysElement.textContent = String(days).padStart(2, "0");
      hoursElement.textContent = String(hours).padStart(2, "0");
      minutesElement.textContent = String(minutes).padStart(2, "0");
      secondsElement.textContent = String(seconds).padStart(2, "0");
    }

    const intervalId = setInterval(updateCountdown, 1000);
    updateCountdown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCountdown);
  } else {
    initCountdown();
  }
})();